import { render, staticRenderFns } from "./SecStudy_SKTC.vue?vue&type=template&id=559d5f1a&scoped=true&"
import script from "./SecStudy_SKTC.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKTC.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKTC.vue?vue&type=style&index=0&id=559d5f1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d5f1a",
  null
  
)

export default component.exports